import { isFunction } from 'utils/utils'
import { logActivity } from 'utils/fpti'
import { getAppConfig } from 'utils/server-data'

export const PPDC_QUALTRICS_SURVEY_KEYS = {
  ENROLLMENT_ABANDONMENT: 'ENROLLMENT_ABANDONMENT',
  CANCEL_CARD: 'CANCEL_CARD',
}

const PPDC_QUALTRICS_SURVEY_KEY_VALUES = {
  ENROLLMENT_ABANDONMENT: 'cardEnrollmentAbondment',
  CANCEL_CARD: 'cancelCard',
}

const SURVEY_TARGETS = {
  PPDC: PPDC_QUALTRICS_SURVEY_KEY_VALUES,
}

export const loadAndOpenQualtricsSurveyWidget = ({
  card = 'PPDC',
  type = '',
  pageTag = '',
  isOnClose = false,
  closeUrl = '',
  fallback,
}) => {
  if (!card || !type || !pageTag) {
    return
  }

  const paypalAnalytics = window.PAYPAL && window.PAYPAL?.analytics
  const reloadQualtricsFunction = isOnClose
    ? paypalAnalytics.qualtricsInterceptInterrupt
    : paypalAnalytics?.reloadQualtrics

  const surveyKey = SURVEY_TARGETS[card][type]
  const qualtricsSurveyData = getAppConfig('qualtricsSurvey')
  const { interceptId, targetValue } = qualtricsSurveyData[surveyKey] || {}

  if (targetValue && isFunction(reloadQualtricsFunction)) {
    logActivity(pageTag, {
      message: `Qualtrics survey triggered. Details - card: ${card}, type: ${type}`,
    })

    if (isOnClose) {
      reloadQualtricsFunction(interceptId, targetValue, `${window.location.origin}${closeUrl}`)
    } else {
      reloadQualtricsFunction(targetValue)
    }
    return
  }

  logActivity(pageTag, {
    errorMessage: `Invalid survey target value. Details - card: ${card}, type: ${type}`,
  })

  // if qualtrics target value mismatched
  if (isOnClose && typeof fallback === 'function') {
    fallback()
  }
}
